import LoggerProvider from './LoggerProvider';

export default class LoggerService {
  constructor({ id, target/* , context, coursewareType */ }) {
    this.id = id;
    this.target = target;
  }

  debug(data) {
    return LoggerProvider.debug(this.target, data);
  }

  error(data) {
    return LoggerProvider.error(this.target, data);
  }

  info(data) {
    return LoggerProvider.info(this.target, data);
  }

  warn(data) {
    return LoggerProvider.warn(this.target, data);
  }

  static build(args) {
    return new LoggerService(args);
  }
}
